// extracted by mini-css-extract-plugin
export default {"root":"NotFound-root-fb069542eaffcde9277a105cfb203425"};